import { Box } from '@mui/material';
import { Check, Plus } from '@sweep-io/sweep-design/dist/icons';
import { colors, Typography } from '@sweep-io/sweep-design';
import { useAddToCanvas } from './useAddToCanvas';
import { BiEventName } from '../../../../../services/events';
import useSendBiEvent from '../../../../../hooks/useSendBiEvent';

interface AddToCanvasButtonProps {
  isStaticView?: boolean;
  isInCanvas: boolean;
  isHovered?: boolean;
  element: { metadataId?: string; label?: string; parentType?: string; type?: string };
  callback?: () => void;
  crmOrgId: string;
  biEventName: BiEventName;
}

export const AddToCanvasButton = ({
  isStaticView,
  isInCanvas,
  isHovered,
  element,
  crmOrgId,
  callback,
  biEventName,
}: AddToCanvasButtonProps) => {
  const onAddToCanvas = useAddToCanvas();
  const sendBiEvent = useSendBiEvent();

  if (!element.metadataId || !element.label || !element.parentType) {
    return null;
  }

  const renderButton = () => {
    return (
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          onAddToCanvas({
            element: { ...element, dependencyType: element.type! },
            crmOrgId,
            callback,
          });
          sendBiEvent({ name: biEventName });
        }}
      >
        <Plus color={colors.blue[500]} />
        <Typography variant="caption" color={colors.blue[500]}>
          Add to Canvas
        </Typography>
      </Box>
    );
  };

  if (isInCanvas) {
    return (
      <Box display="flex" alignItems="center" gap={0.5}>
        <Check color={colors.grey[800]} />
        <Typography variant="caption" color={colors.grey[800]}>
          Added to Canvas
        </Typography>
      </Box>
    );
  }

  if (isStaticView) {
    return renderButton();
  }

  if (isHovered) {
    return renderButton();
  }

  return null;
};
